export const setDateStart = "SET_DATE_START";
export const setDateEnd = "SET_DATE_END";
export const clearDates = "CLEAR_DATES";
export const setDefaultDates = "SET_DEFAULT_DATES";